export default function Footer() {
    return (
        <div>
            <hr className="mt-6 mb-3 border-slate-400 sm:mx-auto dark:border-gray-700 lg:my-8" />
            <span className="block mt-3 mb-6 text-md text-slate-400 text-center font-mono">
               <a href="https://redfrogss.dev" className="hover:underline">Jacky FAN</a> @ 2022. Check out the <a href="https://github.com/redfrogsss/redfrogss.dev" className="hover:underline">Dirty Code</a> here!
            </span>
        </div>
    )
}